import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getCurrentFmsId } from "../actions/FmsActions";
import { addAlert } from "../actions/alertActions";

const PlatformUpAndFms = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const apiUp = () => {
    return axios
      .get(`${window.GENESIS_CMS_API_URL}/v2/up`)
      .then((response) => {
        window.GENESIS_APIUP = response.data.IsUp;
        const isUnity = response.data.IsUnity;
        localStorage.setItem("IsUnity", isUnity);

        if (
          isUnity &&
          localStorage.getItem("OrganizationId") &&
          localStorage.getItem("GivingChurchId") &&
          localStorage.getItem("SessionId")
        ) {
          getCurrentFmsId();
        }
      })
      .catch(() => {
        window.GENESIS_APIUP = false;
        dispatch(
          addAlert({
            message: i18n.t("banners.apiDown"),
            clearable: false,
            type: "banner",
            id: "API",
            global: true,
          })
        );
      });
  };

  useEffect(() => {
    apiUp();
  }, [location.pathname]);

  return null;
};

export default PlatformUpAndFms;
